const stats = [
  { value: "$89", label: "Diagnostic Call" },
  { value: "Same-Day", label: "Service Available" },
  { value: "30-Day", label: "Workmanship Guarantee" },
  { value: "12", label: "Miami-Dade Areas" },
];

export default function NeighborhoodStats() {
  return (
    <section className="w-full bg-[#047857] py-8 md:py-10 px-4 md:px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
        {stats.map((s) => (
          <div key={s.label} className="text-center text-white">
            <div className="font-roboto font-bold text-2xl md:text-3xl mb-1">{s.value}</div>
            <div className="text-sm opacity-90">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}